import { useCallback, useEffect, useState } from "react";

import { Toast, ToastContainer } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MdRingVolume } from "react-icons/md";

import { getPeerNo } from "@/new_utils";

export default function IncomingCallToast() {
  const [show, setShow] = useState(false);
  const [call, setCall] = useState<Nullable<AcdCallEventType>>(null);
  const { t } = useTranslation(["acd"]);

  const incomingCallHandler = useCallback((event: IncomingCallEvent) => {
    const peerNo = getPeerNo(event.detail.event);
    if (!peerNo || !event.detail.line) {
      return;
    }

    setCall(event.detail);
    setShow(true);
  }, []);

  const callEnded = useCallback(() => {
    setShow(false);
    setCall(null);
  }, []);

  useEffect(() => {
    document.addEventListener("tt:incomingCall", incomingCallHandler);
    document.addEventListener("tt:callEnd", callEnded);

    return () => {
      document.removeEventListener("tt:incomingCall", incomingCallHandler);
      document.removeEventListener("tt:callEnd", callEnded);
    };
  }, [callEnded, incomingCallHandler]);

  const peerNo = call ? getPeerNo(call.event) : null;

  return (
    <ToastContainer className="TT-incoming-call-toast-container" containerPosition="fixed" position="top-end">
      <Toast animation show={show && !!call} onClose={() => setShow(false)}>
        <Toast.Header>
          <MdRingVolume className="TT-incoming-call-toast-icon" />
          <strong className="TT-incoming-call-toast-title">{t("acd:incoming_call.incoming_call")}</strong>
        </Toast.Header>

        {!!call && (
          <Toast.Body>
            <div>
              {t("acd:incoming_call.line")}: {call.line?.name}
            </div>
            <div>
              {t("acd:dialer.phone_no")}: {peerNo}
            </div>
            {!!call.line?.greeting && (
              <div>
                {t("acd:incoming_call.greeting")}: {call.line.greeting}
              </div>
            )}
          </Toast.Body>
        )}
      </Toast>
    </ToastContainer>
  );
}
